/**
 * Sets a class -is-scrolled on the body when the user scrolled over a certain
 * threshold which defaults to 64px (default header height).
 * @param {int} scrollThreshold 
 */
export function SetupIsScrolledDetector(scrollThreshold = 64) {

  let isScrolled = false;

  const handleScroll = () => {
    if (!isScrolled && window.scrollY > scrollThreshold) {
      document.body.classList.add("-is-scrolled");
      isScrolled = true;
    } else if (isScrolled && window.scrollY <= scrollThreshold) {
      document.body.classList.remove("-is-scrolled");
      isScrolled = false;
    }
  };

  window.addEventListener('scroll', handleScroll)
  handleScroll();
}